<template>
  <div v-if="isSignature" class="d-flex flex-row align-items-center w-100">
    <h6 class="text-neutral-600 mr-3">{{ item.name }}</h6>
    <span class="text-positive-600 mx-3">R$ {{ formatPrice(item.price) }}</span>
    <span class="text-neutral-076 mx-3">|</span>
    <span class="fs-14 text-secondary-400">
      {{
        !item.num_max_payments
          ? "Recorre até o cliente cancelar"
          : `${item.num_max_payments} recorrências`
      }}
    </span>
    <span class="text-neutral-076 mx-3">|</span>
    <span class="fs-14 text-secondary-400">
      {{
        item.test_days
          ? `${item.test_days} dias de teste`
          : "Sem período de teste"
      }}
    </span>
    <div class="d-flex ml-auto gap-5">
      <bp-button
        size="sm"
        icon="fa-light fa-pencil"
        color="neutral"
        variant="filled-1"
        @click="$emit('edit', index)"
      />
      <bp-button
        class="ml-auto"
        variant="filled-1"
        color="negative"
        icon="fa-light fa-trash"
        size="sm"
        @click="$emit('delete', index)"
      />
    </div>
  </div>

  <div v-else class="offer-item">
    <div
      class="d-flex flex-row align-items-md-center w-100 justify-content-between"
      @click="visible = !visible"
      :aria-controls="`order-bump-details-${index}`"
      :class="`order-bump-details-${index}`"
    >
      <div class="d-flex flex-column flex-md-row align-items-md-center gap-4">
        <h6 class="text-neutral-600">{{ item.name }}</h6>
        <span class="text-neutral-076 d-none d-md-block">|</span>
        <span class="text-positive-600 ">R$ {{ formatPrice(item.price) }}</span>
        <span
          class="d-flex align-items-center gap-4"
          v-if="item.order_bumps.length"
        >
          <span class="text-neutral-076 d-none d-md-block">|</span>
          <div class="dashed-icon">
            <i class="fa-light fa-cart-plus text-information-500"></i>
          </div>
        </span>
      </div>
      <div
        class="d-flex flex-column flex-md-row gap-3 align-items-end align-items-md-center responsive-collapse"
      >
        <span class="fs-14 text-neutral-400 order-1 order-md-0 text-right">{{
          formatDate(item)
        }}</span>
        <div>
          <bp-button
            variant="filled-1"
            class="order-0 order-md-1 "
            color="neutral"
            :icon="
              `fa-light ${this.visible ? 'fa-chevron-up' : 'fa-chevron-down'}`
            "
            size="sm"
          ></bp-button>
        </div>
      </div>
    </div>
    <b-collapse
      v-model="visible"
      :id="`order-bump-details-${index}`"
      class="mt-5 mb-3 w-100"
    >
      <span class="fs-14 text-neutral-500" v-if="item.order_bumps.length">
        Order Bump cadastrados
      </span>
      <div class="d-flex flex-column">
        <div class="d-flex flex-wrap gap-5">
          <div
            v-for="(orderBump, index) in item.order_bumps"
            class="dashed-order-bump"
            :key="index"
          >
            <span class="text-information-500"
              >{{ orderBump.product_name }}
              <span class="text-information-200 mx-3">|</span>
              {{ orderBump.offer_name }}</span
            >
          </div>
        </div>
        <div
          class="d-flex flex-column flex-md-row justify-content-md-end mt-5 gap-3"
        >
          <bp-button
            size="sm"
            icon="fa-light fa-pencil"
            label="Editar"
            color="neutral"
            variant="filled-1"
            @click="$emit('edit', index)"
          />
          <bp-button
            size="sm"
            icon="fa-light fa-trash"
            label="Excluir"
            color="negative"
            variant="filled-1"
            @click="$emit('delete', index)"
          />
        </div>
      </div>
    </b-collapse>
  </div>
</template>
<script>
import { formatMoney } from "@/functions/helpers";
import moment from "moment";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number
    },
    isSignature: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    };
  },

  mounted() {},

  methods: {
    editItems(index) {
      this.$emit("edit", index);
    },
    formatDate(item) {
      const start = moment(item.start_at).format("DD/MM/YYYY");
      if (item.end_at) {
        const end = moment(item.end_at).format("DD/MM/YYYY");
        return `${start} - ${end}`;
      }
      return `Inicia em ${start}, sem data limite.`;
    },
    formatPrice(val) {
      return formatMoney(val);
    }
  }
};
</script>
<style lang="scss" scoped>
.dashed-order-bump {
  border: 1px dashed #99c2ff;
  border-radius: 4px;
  padding: 6px 8px;
}
#order-bump-details {
  &.show {
    .offer-plan-box .dashed-icon {
      display: none;
    }
  }
}
.dashed-icon {
  display: flex;
  height: 34px;
  width: 34px;
  justify-content: center;
  align-items: center;
  border: 1px dashed #c0d9ff;
  border-radius: 4px;
  &:has(#order-bump-details.show) {
    display: none;
  }
}
.responsive-collapse {
  @media screen and (max-width: 991px) {
    max-width: 30%;
  }
}
</style>
